import { render, staticRenderFns } from "./BusinessScopeClientRedirect.vue?vue&type=template&id=e54f7e02&"
import script from "./BusinessScopeClientRedirect.vue?vue&type=script&lang=js&"
export * from "./BusinessScopeClientRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports